import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ExtractionGridController::ensure
* @see Http/Controllers/ExtractionGridController.php:19
* @route '/extraction/projects/{project}/grid/ensure'
*/
export const ensure = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ensure.url(args, options),
    method: 'post',
})

ensure.definition = {
    methods: ["post"],
    url: '/extraction/projects/{project}/grid/ensure',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ExtractionGridController::ensure
* @see Http/Controllers/ExtractionGridController.php:19
* @route '/extraction/projects/{project}/grid/ensure'
*/
ensure.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return ensure.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionGridController::ensure
* @see Http/Controllers/ExtractionGridController.php:19
* @route '/extraction/projects/{project}/grid/ensure'
*/
ensure.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ensure.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::ensure
* @see Http/Controllers/ExtractionGridController.php:19
* @route '/extraction/projects/{project}/grid/ensure'
*/
const ensureForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ensure.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::ensure
* @see Http/Controllers/ExtractionGridController.php:19
* @route '/extraction/projects/{project}/grid/ensure'
*/
ensureForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ensure.url(args, options),
    method: 'post',
})

ensure.form = ensureForm

/**
* @see \App\Http\Controllers\ExtractionGridController::show
* @see Http/Controllers/ExtractionGridController.php:34
* @route '/extraction/projects/{project}/grid'
*/
export const show = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/extraction/projects/{project}/grid',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ExtractionGridController::show
* @see Http/Controllers/ExtractionGridController.php:34
* @route '/extraction/projects/{project}/grid'
*/
show.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return show.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionGridController::show
* @see Http/Controllers/ExtractionGridController.php:34
* @route '/extraction/projects/{project}/grid'
*/
show.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::show
* @see Http/Controllers/ExtractionGridController.php:34
* @route '/extraction/projects/{project}/grid'
*/
show.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::show
* @see Http/Controllers/ExtractionGridController.php:34
* @route '/extraction/projects/{project}/grid'
*/
const showForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::show
* @see Http/Controllers/ExtractionGridController.php:34
* @route '/extraction/projects/{project}/grid'
*/
showForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::show
* @see Http/Controllers/ExtractionGridController.php:34
* @route '/extraction/projects/{project}/grid'
*/
showForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\ExtractionGridController::destroy
* @see Http/Controllers/ExtractionGridController.php:49
* @route '/extraction/projects/{project}/grid'
*/
export const destroy = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/extraction/projects/{project}/grid',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ExtractionGridController::destroy
* @see Http/Controllers/ExtractionGridController.php:49
* @route '/extraction/projects/{project}/grid'
*/
destroy.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionGridController::destroy
* @see Http/Controllers/ExtractionGridController.php:49
* @route '/extraction/projects/{project}/grid'
*/
destroy.delete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::destroy
* @see Http/Controllers/ExtractionGridController.php:49
* @route '/extraction/projects/{project}/grid'
*/
const destroyForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::destroy
* @see Http/Controllers/ExtractionGridController.php:49
* @route '/extraction/projects/{project}/grid'
*/
destroyForm.delete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\ExtractionGridController::syncRows
* @see Http/Controllers/ExtractionGridController.php:62
* @route '/extraction/grids/{grid}/sync-rows'
*/
export const syncRows = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: syncRows.url(args, options),
    method: 'post',
})

syncRows.definition = {
    methods: ["post"],
    url: '/extraction/grids/{grid}/sync-rows',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ExtractionGridController::syncRows
* @see Http/Controllers/ExtractionGridController.php:62
* @route '/extraction/grids/{grid}/sync-rows'
*/
syncRows.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return syncRows.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionGridController::syncRows
* @see Http/Controllers/ExtractionGridController.php:62
* @route '/extraction/grids/{grid}/sync-rows'
*/
syncRows.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: syncRows.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::syncRows
* @see Http/Controllers/ExtractionGridController.php:62
* @route '/extraction/grids/{grid}/sync-rows'
*/
const syncRowsForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: syncRows.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::syncRows
* @see Http/Controllers/ExtractionGridController.php:62
* @route '/extraction/grids/{grid}/sync-rows'
*/
syncRowsForm.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: syncRows.url(args, options),
    method: 'post',
})

syncRows.form = syncRowsForm

/**
* @see \App\Http\Controllers\ExtractionGridController::rows
* @see Http/Controllers/ExtractionGridController.php:90
* @route '/extraction/grids/{grid}/rows'
*/
export const rows = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rows.url(args, options),
    method: 'get',
})

rows.definition = {
    methods: ["get","head"],
    url: '/extraction/grids/{grid}/rows',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ExtractionGridController::rows
* @see Http/Controllers/ExtractionGridController.php:90
* @route '/extraction/grids/{grid}/rows'
*/
rows.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return rows.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionGridController::rows
* @see Http/Controllers/ExtractionGridController.php:90
* @route '/extraction/grids/{grid}/rows'
*/
rows.get = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rows.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::rows
* @see Http/Controllers/ExtractionGridController.php:90
* @route '/extraction/grids/{grid}/rows'
*/
rows.head = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: rows.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::rows
* @see Http/Controllers/ExtractionGridController.php:90
* @route '/extraction/grids/{grid}/rows'
*/
const rowsForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rows.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::rows
* @see Http/Controllers/ExtractionGridController.php:90
* @route '/extraction/grids/{grid}/rows'
*/
rowsForm.get = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rows.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionGridController::rows
* @see Http/Controllers/ExtractionGridController.php:90
* @route '/extraction/grids/{grid}/rows'
*/
rowsForm.head = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rows.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

rows.form = rowsForm

const ExtractionGridController = { ensure, show, destroy, syncRows, rows }

export default ExtractionGridController